/* eslint-disable react/require-default-props,react/destructuring-assignment,class-methods-use-this */

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const ONE_MINUTE = 60000;

export class Timeago extends React.Component {
  static propTypes = {
    time: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    format: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      intervalId: null,
      time: this.timeago(props.time, props.format),
    };
  }

  componentWillMount() {
    const intervalId = setInterval(() => {
      this.updateTime();
    }, ONE_MINUTE);
    this.setState({ intervalId });
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  updateTime() {
    const time = this.timeago(this.props.time, this.props.format);
    this.setState({ time });
  }

  timeago(time, format) {
    const momentTime = moment(time);
    return {
      title: format ? momentTime.format(format) : momentTime.toString(),
      human: momentTime.fromNow(),
    };
  }

  render() {
    const { time } = this.state;
    return <time-ago title={time.title}>{time.human}</time-ago>;
  }
}
